import {component_tool} from "@/tool";

let {WizModal} = component_tool;
//配置项
let componentName = 'groupManagement'
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "createBy",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "delFlag",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "名称",
    name: "searchName",
    searchItem: {}
  },
  {
    title: "名称",
    name: "name",
    tableItem: {},
    formItem: {
      rules: [{
        required: true,
        message: '请输入账号',
      }]
    }
  },
  {
    title: "编号",
    name: "searchCode",
    searchItem: {}
  },
  {
    title: "编号",
    name: "code",
    tableItem: {},
    formItem: {
      rules: [{
        required: true,
        message: '请输入编号',
      }]
    }
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      {code: "ENABLE", codeName: "有效"},
      {code: "PROHIBIT", codeName: "无效"}
    ],
    searchItem: {
      type: "select"
    },
    formItem: {
      type: "radio",
      initialValue: "ENABLE"
    }
  },
  {
    title: "创建日期",
    name: "createTime",
    tableItem: {},
    formItem: {
      type: "hidden"
    }
  }
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        cols: {
          xs: 24,
          md: 12,
          xl: 8
        },
        buttonSort: ['add', 'delete'],
      },
      modalFormProps: {
        key: "modal123",
        params: {
          modalParams: {
            title: "Modal",
            children: "Bla bla123 .."
          }
        }
      },
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false,
      },
      rowOperateSort: ['update', 'enableOrDisable', 'userGroupStaffManagement'],
      rowOperateView: [
        {
          key: "enableOrDisable",
          custom: true,
          params: {children: "启用"},
          textFormat: {
            recordKey: 'state',
            dirt: {'ENABLE': '禁用', 'PROHIBIT': '启用'}
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "updateGroupState",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${
                record['state'] === "ENABLE" ? "禁用" : "启用"
              }该用户组吗？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    state: record['state'] === "ENABLE" ? "PROHIBIT" : "ENABLE",
                    id: record['id']
                  })
                },
                onCancel() { 
                }
              });
              return null
            }
          }
        },
        {
          key: "userGroupStaffManagement",
          custom: true,
          params: {children: "用户组人员管理"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/auth/group/groupUser"
            }
          }
        }
      ],
      commonOperate: {
        add: true,
        delete: true,
        update: true

      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/groupList`,
    payload: {
      key: `${componentName}@groupList`,
      apiParams: {pageNum: 1, pageSize: 10}
    }
  },
  add: {
    path: `${componentName}/addGroup`,
    payload: {
      key: `${componentName}@addGroup`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/updateGroup`,
    payload: {
      key: `${componentName}@updateGroup`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/deleteGroup`,
    payload: {
      key: `${componentName}@deleteGroup`,
      apiParams: {}
    }
  },
  updateGroupState: {
    path: `${componentName}/updateGroupState`,
    payload: {
      key: `${componentName}@updateGroupState`,
      apiParams: {}
    }
  }
};


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
